export default "__VITE_PUBLIC_ASSET__ff683c16__"